module.exports = __webpack_public_path__ + "static/media/selling-water-revenue-03.83f3004a.jpg";